import { needsMfaEnrollment } from './mfaPolicy';
import type { MaicUser } from '../shell/TenantContext';

/** Whether the shell must hold this user on an onboarding screen (temporary
 *  password, MFA enrollment) before they reach anything else. AuthGate and the
 *  share viewer both read it: they must agree, or a share link bounces between
 *  them forever. The dev escape hatch VITE_DISABLE_MFA=true skips MFA. */
export function onboardingPending(user: MaicUser | null | undefined): boolean {
  return !!user?.mustChangePassword
    || (import.meta.env.VITE_DISABLE_MFA !== 'true' && needsMfaEnrollment(user));
}
